const { convertRemValuesForWebstoreRoot } = require('./rp-ui-webstore-rem-postcss');

/**
 * Scales rp-ui Emotion rem values for webstore's 16px html root (matches postcss-scope-island-root).
 * @param {import('stylis').Element} element
 * @returns {void}
 */
function scaleRpUiRemStylisPlugin(element) {
	if (element.type !== 'decl' || element.return) {
		return;
	}

	const declarationValue = element.value;
	if (typeof declarationValue !== 'string' || !declarationValue.includes('rem')) {
		return;
	}

	element.value = convertRemValuesForWebstoreRoot(declarationValue);
}

module.exports = { scaleRpUiRemStylisPlugin };
